<div class="even">
    <mat-label class="subHeading">Premium Base<span *ngIf="isRequired" class="star">*</span></mat-label>
<button class="side" (click)="form.controls['premium_base'].setValue(null)">Remove</button>
</div>
<mat-select formControlName="premium_base" class="premium" placeholder="{{isRequired ? 'Select' : 'All'}}">
    <mat-option *ngFor="let premiumBase of premiumBaseTypes" [value]="premiumBase">{{premiumBase}}</mat-option>
</mat-select>